const styles = (theme) => ({
  flexRow: {
    maxWidth: 240,
    marginBottom: 22,
  },
  selectRoot: {
    marginTop: 0,
    marginBottom: 0,
  },
  inputField: {
    height: 28,
    padding: 0,
  },
  inputLabel: {
    paddingTop: 6,
  },
  notesLabel: {
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    lineHeight: "16px",
    color: theme.dispatchPanelLabelValueColor,
  },
  fullWidth: {
    marginTop: 6,
    width: "100%",
    flex: 1,
  },
  innerPaddingField: {
    padding: 10,
    lineHeight: 1.4,
    color: theme.TextColor,
    fontSize: theme.textFontSize,
  },
  input: {
    resize: "auto"
  }
});

export default styles;
